import styles from './person.module.css';
import { Provider } from 'react-redux';
import PersonComponent from './person';
import { personStore } from './reducers/store';

function PersonApp (props) {
    return(
        <Provider store={personStore} >
            <PersonComponent company={props.company}/>
        </Provider>
    )
}

export default PersonApp;